import { useParams } from 'react-router-dom';

import { useGetPatientQuery } from '~/store/services/patients';
import { getPreferredFirstName } from '~/lib/util/patient.util';
import PatientMessagesTab from '~/components/maud/patients/profile/tabs/patientMessagesTab/PatientMessagesTab';

const MessagesPage = () => {
  const { patientId } = useParams<{ patientId: string }>();

  const { data: patient } = useGetPatientQuery(
    { patientId },
    { skip: !patientId },
  );

  if (!patient) return null;

  return (
    <PatientMessagesTab
      patient={patient}
      patientFirstName={getPreferredFirstName(
        patient.chosenName,
        patient.firstName,
      )}
      patientId={patientId}
    />
  );
};

export default MessagesPage;
